fx.ns("desktop.common.behaviour", class ComponentDragger extends fx.EventDispatcher{

    constructor(model, editor)
    {    
        super();

        this.model = model;
        this.creation = model.creation;
        this.editor = editor;
        this.precision = this.creation.extraScale * fx.get("settings").precision;

        // TODO : to check this out
        //if (this.editor)
        //    this.on("mousedown", this._onMouseDown, this.editor);

        this.on("blur", this._onMouseUp, window);

        this._draggData = {};

        // let's detect picture uploaded
        this.on("updated", this._onUpdated, this.creation.parentModel);
    }

    // If we are dragging a picture, and it's begin uploaded, once it's uploaded, it's ID is updated, so we have to update dragging image content propoerty
    _onUpdated(e)
    {
        if (!this._draggData)
            return;

        if ( e.action.type == "update" && e.action.model instanceof models.Photo )
        {
            if (e.action.previous.id == this._draggData.content)
                this._draggData.content = e.action.data.id;

            if (this._draggData.contents)
            {
                for (let i = 0; i < this._draggData.contents.length; i++)
                    if (this._draggData.contents[i] == e.action.previous.id)
                        this._draggData.contents[i] = e.action.data.id;
            }
        }
    }

    get book()
    {
        return this._book;
    }

    set book(val)
    {
        this._book = val;
    }

    get editor()
    {
        return this._editor;
    }

    set editor(val)
    {
        if (this._editor)
            this.off("mousedown", this._onMouseDown, this.editor);

        this._editor = val;

        if (this._editor)
            this.on("mousedown", this._onMouseDown, this.editor);
    }

   

    _selectedPhotoCount()
    {
        let n = 0;
        if (this.model && this.model.photos)
            for (let i = 0; i < this.model.photos.length; i++)
            {
                let p = this.model.photos.getItemAt(i);
                if (p && p.selected && !p.deleted)
                    n++;
            }
        return n;
    }

    _onMouseDown(e)
    {
        if (e.which != 1) return;
        
        if (this._draggData && this._draggData.moveBackTimer)
            return;

        let element = fx.dom.parent(e.target, ".draggable");
        if ( element )
        {
            e.preventDefault()

            this._listen(true);

            fx.dom.css(element, {opacity : 0, transition : "transform 0.5s, opacity 0.25s"} );

            this._draggData.dragging = true;
            this._draggData.element = element;
            this._draggData.class = element.getAttribute("data-class");
            this._draggData.bgcolor = element.getAttribute("data-bgcolor");    
            this._draggData.behaviour = element.getAttribute("data-behaviour");

            if (this._draggData.class == "Text")
            {
                let text = this.model.texts.find({id : element.getAttribute("data-id")});
                this._draggData.content = text.content;
                this._draggData.contentid =  element.getAttribute("data-id");
            }
            else
                this._draggData.content =  element.getAttribute("data-id");

            // multi-drag: if the grabbed photo is part of a multi-selection, drag all of it.
            // The gallery stamps "photo-selected" on selected photos, so an unselected grab
            // (and every non-book editor) skips the full scan below.
            this._draggData.contents = null;
            this._draggData.group = false;

            // a draggable can declare its own multi-photo payload (a date group in the gallery)
            let declared = element.getAttribute("data-contents");
            if (declared)
            {
                let ids = declared.split(",").filter(function(id){ return id.length; });
                if (ids.length)
                {
                    this._draggData.contents = ids;
                    this._draggData.group = true;   // a plain click on it must not add/toggle a photo
                }
            }
            else
            if (this._draggData.class == "Photo" && this.model && this.model.photos
                && element.closest && element.closest(".photo-selected"))
            {
                let draggedId = element.getAttribute("data-id");
                let selected = [];
                for (let i = 0; i < this.model.photos.length; i++)
                {
                    let p = this.model.photos.getItemAt(i);
                    if (p && p.selected && !p.deleted)
                        selected.push(String(p.id));
                }

                if (selected.length > 1 && selected.indexOf(String(draggedId)) != -1)
                    this._draggData.contents = selected;
            }

            let multiDrag = this._draggData.contents && this._draggData.contents.length > 1;

            let position = fx.dom.offset(element);
            let width = element.getAttribute("width") || fx.dom.width(element);
            let height = element.getAttribute("height") || fx.dom.height(element);

            this._draggData.startPosition = {x : position.left, y : position.top};

            if (multiDrag)
            {
                // white square with the photo count instead of the thumbnail
                this._draggData.draggedElement = document.createElement("div");
                this._draggData.draggedElement.textContent = this._draggData.contents.length;
                fx.dom.addClass(this._draggData.draggedElement, "drag-count");
            }
            else
                this._draggData.draggedElement = element.cloneNode(true);

            fx.dom.addClass(this._draggData.draggedElement, "dragging");
            this._draggData.draggedElement.id = Utils.newID();
            this._draggData.position = {x : e.pageX, y : e.pageY};
            this._draggData.offset = {   
                offsetX : e.pageX - position.left,
                offsetY : e.pageY - position.top,
                width : width, 
                height : height,
                originalWidth : Number( element.getAttribute("data-width") || width),
                originalHeight : Number( element.getAttribute("data-height") || height),
            };

            this._draggData.ratio = this._draggData.offset.originalWidth ? (this._draggData.offset.originalWidth /  this._draggData.offset.originalHeight ) : 1;
            
            let xPos = position.left;
            let yPos = position.top;
            
            fx.dom.css(this._draggData.draggedElement, {"position" : "absolute",  
                                                        "cursor" : "grabbing", 
                                                        "opacity" : 1, 
                                                        "z-index" : 10, 
                                                        "transform":"translate3d(0px, 0px, 0px)",
                                                        "transform-origin" : "center",
                                                        "left" : xPos,
                                                        "top" : yPos,
                                                        "width" : width,
                                                        "height" : height});

            if (multiDrag)
            {
                // fixed square centered under the cursor
                let size = 90;
                fx.dom.css(this._draggData.draggedElement, {"width" : size, "height" : size});
                this._draggData.offset.offsetX = size / 2;
                this._draggData.offset.offsetY = size / 2;
            }

            document.body.appendChild( this._draggData.draggedElement );

           fx.set("dragging", true);
        }
    }

    _onMouseMove(e)
    {
        if (!this._draggData || !this._draggData.offset)
            return;

        let isMulti = this._draggData.contents && this._draggData.contents.length > 1;

        let xPos = e.pageX - this._draggData.offset.offsetX;
        let yPos = e.pageY - this._draggData.offset.offsetY;
        let elts = fx.graphics.elementsFromPoint(e.pageX, e.pageY,2);
        let elements = [];
        
        for (let i = 0; i < elts.length; i++)
        {
            if (fx.dom.parent(elts[i], ".backcover"))
            {
                elements = [];
                break;
            }

            let element = fx.dom.parent(elts[i], "." + this._draggData.class);
            if (!element && fx.dom.hasClass(elts[i], "Stage") )
                element = elts[i];
            
            if (element && elements.indexOf(element) == -1)
                elements.push(element);
        }
        
        this._draggData.newPosition =  {left : xPos, top : yPos};

        if (elements.length == 0)
        {
            if (this._draggData.overPageComponent)
            {
                this._draggData.overPageComponent.event("drag-out"); 
                fx.dom.css(this._draggData.draggedElement, {opacity:1});
                this._draggData.overPageComponent = null;
            }

            this._draggData.overComponent = null;
            this._draggData.dropAllowed = false;
            this._draggData.area = null;
            this._draggData.page = null;
        }

        for (let i = 0; i < elements.length; i++)
        {
            let element = elements[i];
            if (element == this._draggData.draggedElement || fx.dom.parent(element, ".Frame"))
                continue;

            let area = fx.dom.parent(element, ".Stage") ? fx.dom.parent(element, ".Area") : null;
            
            //let areaDataId = area ? area.getAttribute("data-id") : null;
            let areaDataId = area ? area.getAttribute("id") : null;
            this._draggData.area = area;
            this._draggData.scale = fx.graphics.getScale( this._draggData.area );
            //this._draggData.page = areaDataId ? this.creation.getElement(areaDataId) : null;
            let pageComponent = areaDataId ? fx.get("objects")[areaDataId] : null;
            this._draggData.page = pageComponent ? pageComponent.data : null;
          
            let component = fx.dom.parent(element, "." + this._draggData.class);
            let componentDataId = component ? component.getAttribute("data-id") : null;
            
            if (this._draggData.overPageComponent && this._draggData.overPageComponent.id != componentDataId)
            {
                this._draggData.overPageComponent.event("drag-out"); 
                fx.dom.css(this._draggData.draggedElement, {opacity:1});
                this._draggData.overPageComponent = null;
                this._draggData.overComponent = null;
                this._draggData.dropAllowed = false;
            }

            if (this._draggData.page)
            {
                let pageComponent = componentDataId ? this._draggData.page.getComponent( componentDataId ) : null ;

                this._draggData.overPageComponent = pageComponent;
                this._draggData.overComponent = component;
                this._draggData.dropAllowed = component ? component.getAttribute("data-drop-allowed"): false;

                if (pageComponent) // drag over picture, show picture (sticker : no, background : yes, text : no)
                {
                    // single-slot preview only for a single drag ; a multi-drag previews the whole
                    // layout at page level (see _reconcilePreview), so don't fight it here.
                    if (this._draggData.dropAllowed && !isMulti)
                    {
                        pageComponent.event("drag-over", {overcontent : this._draggData.content, draggedElement : this._draggData.draggedElement});
                        fx.dom.css(this._draggData.draggedElement, {opacity:0.4});
                        this._draggData.newPosition.transform = "scale(0.6)";
                    }

                    if (!isMulti)
                        break;
                }
                else      
                    this._draggData.newPosition.transform = "scale(" + Math.min(1, this._draggData.scale || 1) + ")"; // TODO : get scale of Area ?        
            }  
             
        }
        
            

        if (isMulti)
            this._reconcilePreview(e);

        fx.dom.css(this._draggData.draggedElement, this._draggData.newPosition);
    }

    // ----- multi-drag live layout preview (fired to the board, rendered view-only) -----

    // which side/half of the hovered page the layout would land on (mirrors _onMouseUp)
    _previewSide(e)
    {
        if (!this._draggData.area) return "";

        let position = fx.dom.offset(this._draggData.area);
        let scale = this._draggData.scale || fx.graphics.getScale(this._draggData.area) || 1;
        let localX = (e.pageX - position.left) / scale;

        if (this._draggData.page && this._draggData.page.isCover)
        {
            if (localX < this.creation.pageWidth) return "left";
            if (localX <= this.creation.pageWidth + this.creation.sliceWidth) return "center";
            return "right";
        }

        return (localX < this.creation.pageWidth) ? "left" : "right";
    }

    // emit preview-layout / preview-clear when the hovered page or side changes
    _reconcilePreview(e)
    {
        let page = this._draggData.page;
        let side = page ? this._previewSide(e) : "";
        let areaId = this._draggData.area ? this._draggData.area.getAttribute("data-id") : null;
        let key = page ? (areaId + ":" + side) : null;

        if (key == this._draggData.previewKey)
            return;

        if (this._draggData.previewKey)
            this.creation.event("preview-clear");

        this._draggData.previewKey = key;

        if (page && this._draggData.contents)
            this.creation.event("preview-layout", { contents : this._draggData.contents, side : side, area : areaId });
    }

    _clearPreview()
    {
        if (this._draggData && this._draggData.previewKey)
        {
            this.creation.event("preview-clear");
            this._draggData.previewKey = null;
        }
    }

    _onMouseUp(e)
    {
        // tear down any live layout preview before committing / restoring
        this._clearPreview();

        if (this._draggData.dragging)
        {
            let isMulti = this._draggData.contents && this._draggData.contents.length > 1;

            // drag vs click : small pixel threshold so click-to-place / click-to-select
            // survive 1-2px jitter (master's x!=ex && y!=ey mis-classified single-axis moves)
            let dx = Math.abs(this._draggData.position.x - e.pageX);
            let dy = Math.abs(this._draggData.position.y - e.pageY);

            if (dx > 3 || dy > 3)
            {
                //---- manage drop
                // a multi-drag goes to the page (layout), never a single slot replacement
                if (!isMulti && this._draggData.overPageComponent && this._draggData.overComponent.getAttribute("data-drop-allowed"))
                {
                    this._draggData.overPageComponent.event("drag-out"); 

                    if (this._draggData.overPageComponent.content != this._draggData.content || this._draggData.bgcolor)
                    {
                        let update = {content : this._draggData.content};
                        if (this._draggData.contentid)
                            update.contentid = this._draggData.contentid;

                        if (this._draggData.bgcolor)
                            update.bgcolor = this._draggData.bgcolor

                        //this._draggData.overPageComponent.update("drop", update); 
                        this._draggData.overPageComponent.event("drop", update);
                    }

                    this._draggData.moveBackTimer = this.delay(this._moveBack, 250);// setTimeout(this._moveBackHandler, 250);

                    fx.dom.css(this._draggData.draggedElement, {"transition" : "opacity 0.25s, transform 0.25s"});
                    fx.dom.css(this._draggData.draggedElement, {opacity:0, transform: "scale(0)"});

                }
                else
                if (this._draggData.page)
                {
                    // reset the hovered slot's drag-over preview so later content updates
                    // (including undo) re-render it. Pages re-layout on drop, but the cover
                    // does not, so a stuck draggingOver would otherwise freeze it.
                    if (this._draggData.overPageComponent)
                    {
                        this._draggData.overPageComponent.event("drag-out");
                        this._draggData.overPageComponent = null;
                    }

                    let position = fx.dom.offset(this._draggData.area);
                    
                    let scale = fx.graphics.getScale( this._draggData.area );
                    let local = {
                                    x: Math.floor( e.pageX - position.left ) / scale,
                                    y: Math.floor( e.pageY - position.top ) / scale
                                };

                    let width, height, componentRatio = ((this._draggData.class == "Sticker" || this._draggData.class == "Shape") ? 0.3 : 0.8); 
                    
                    if (fx.get("app") =="calendar")
                        componentRatio *= 0.4;

                    if (this._draggData.offset.originalWidth > this._draggData.offset.originalHeight)
                    {
                        width = this.creation.pageWidth * componentRatio;
                        height = width / this._draggData.ratio;
                    }
                    else
                    {
                        height = this.creation.pageWidth * componentRatio;
                        width = height * this._draggData.ratio;
                    }
                    

                    let ratioX = (this._draggData.offset.offsetX) / this._draggData.offset.width;
                    let ratioY = (this._draggData.offset.offsetY) / this._draggData.offset.height;
    
                    let x = (local.x  - ( width * ratioX));
                    let y = (local.y - ( height * ratioY));

                    let side;

                    if (fx.get("app") =="calendar")
                    {
                        if (this._draggData.page.isCover)
                        {
                            side = "bottom";
                        }
                        else
                        {
                            if (local.y < this.creation.pageHeight)
                                side = "top";
                            else
                            if (local.y >= this.creation.pageHeight)
                                side = "bottom";
                        }
                    }
                    else
                    if (this._draggData.page.isCover)
                    {
                        if (local.x < this.creation.pageWidth)
                            side = "left";
                        else
                        if (local.x >= this.creation.pageWidth && local.x <= this.creation.pageWidth + this.creation.sliceWidth)
                            side = "center";
                        else
                            side = "right";
                    }
                    else
                        side = (local.x < this.creation.pageWidth) ? "left" : "right";
                    
                    x = x.multipleOf( this.precision );
                    y = y.multipleOf( this.precision );
                    width = Math.max( Math.round(width), width.multipleOf( this.precision ) );
                    height = Math.max( Math.round(height), height.multipleOf( this.precision ) );
                
                    this.creation.event(this._draggData.behaviour || "add-component", {
                        //page : this._draggData.page,
                        content: this._draggData.content,
                        contents: this._draggData.contents,
                        contentid: this._draggData.contentid,
                        bgcolor: this._draggData.bgcolor,
                        component_type : this._draggData.class.toLowerCase(),
                        x : x,
                        y : y,
                        width : width,
                        height : height,
                        side : side,
                        creation : "dropped",
                        area : this._draggData.area.getAttribute("data-id")
                    });

                    this._draggData.moveBackTimer = this.delay(this._moveBack, 0);
                }
                else
                {
                    this._draggData.moveBackTimer = this.delay(this._moveBack, 500);//setTimeout(this._moveBackHandler, 500);
                    

                    fx.dom.css(this._draggData.draggedElement, {"transition" : "top 0.5s ease-out, left 0.5s ease-out"});
                    
                    fx.dom.css(this._draggData.draggedElement, {left : this._draggData.startPosition.x, top : this._draggData.startPosition.y});   
                }
            }
            else
            {
                // if user click on a "clickable element", we sent event to book
                // so it can send it to active page
                
                if (this._draggData.group)
                {
                    // a date group : dragging places its photos, a plain click does nothing
                    // (the date circle toggles the day's selection)
                }
                else
                if (this._draggData.class == "Photo" && this._draggData.element
                    && this._draggData.element.closest && this._draggData.element.closest(".has-selection"))
                {
                    // a selection is active -> a photo click adds it to the selection,
                    // it no longer adds the photo to the page (deselect is always allowed,
                    // selecting is capped like the grid / the per-page drop)
                    let photo = this.model.photos.find({id : this._draggData.content});
                    if (photo)
                    {
                        if (photo.selected)
                        {
                            photo.selected = false;
                            this.creation.event("photo-selection-changed", {photo : photo});
                        }
                        else if (this._selectedPhotoCount() < 10)
                        {
                            photo.selected = true;
                            this.creation.event("photo-selection-changed", {photo : photo});
                        }
                    }
                }
                else
                if (this._draggData.behaviour)
                    this.creation.event(this._draggData.behaviour || "add-component", {    
                                                    content: this._draggData.content, 
                                                    contentid: this._draggData.contentid,
                                                    bgcolor: this._draggData.bgcolor, 
                                                    component_type : this._draggData.class.toLowerCase(),
                                                    creation : "manual"
                                                } );
                
                this._draggData.moveBackTimer = this.delay(this._moveBack, 0);
            }
                
            //---- stop dragging

            
            
        }
        
        this._listen(false);
    }

    _moveBack()
    {
        if (!this._draggData) return;

        this._clearPreview();   // safety net : never leave a preview stuck

        if (this._draggData.element)
        {
            fx.dom.css(this._draggData.element, {transition : "transform 0.5s"} );
            fx.dom.css(this._draggData.element, {opacity: 1});
        }
        
        if (this._draggData.draggedElement && this._draggData.draggedElement.parentNode)
            this._draggData.draggedElement.parentNode.removeChild( this._draggData.draggedElement );

        this._draggData = {};

        fx.set("dragging", false);
    }

    _listen(val)
    {
        if (val)
        {
            this.on("mousemove", this._onMouseMove, window);
            this.on("mouseup", this._onMouseUp, window);
        }   
        else
        {
            this.off("mousemove", this._onMouseMove, window);
            this.off("mouseup", this._onMouseUp, window);
        }
    }


});